export const Users = [
	{
		id: 1,
		profilePicture: "person/1.png",
		username: "Toshmatov Alisher",
	},
	{
		id: 2,
		profilePicture: "person/2.png",
		username: "Eshmatov G'anisher",
	},
];

export const Posts = [
	{
		id: 1,
		desc: "Hello my love , I miss you !",
		photo: "post/1.png",
		date: "5 mins ago",
		userId: 1,
		like: 32,
		comment: 10,
	},
	{
		id: 2,
		desc: "What is your name ?",
		photo: "post/2.png",
		date: "1 hour ago",
		userId: 2,
		like: 12,
		comment: 4,
	},
	{
		id: 3,
		desc: "What is not my name",
		photo: "post/3.png",
		date: "5 hour ago",
		userId: 2,
		like: 17,
		comment: 8,
	},
];
